import { Component, OnInit, Input, ChangeDetectionStrategy } from '@angular/core';
import { PayerService } from '../../service/data/payer.service';
import { IncorrectPaymentService } from '../../service/data/incorrect-payment.service';
import { Payer } from '../../model/payer';
import { FormGroup, FormBuilder } from '@angular/forms';
import { FormControlExFactory } from '../../../core/service/factory/form-control-ex-factory.service';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { IncorrectPayment } from '../../model/incorrect-payment';

@Component({
    selector: 'app-change-incorrect-payment-payer-form',
    templateUrl: './change-incorrect-payment-payer-form.component.html',
    styleUrls: ['./change-incorrect-payment-payer-form.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ChangeIncorrectPaymentPayerFormComponent implements OnInit {
  constructor(
    private _dialogService: ActionWindowService,
    private _payerService: PayerService,
    private _paymentService: IncorrectPaymentService,
    fb: FormBuilder,
    fcf: FormControlExFactory
  ) {
    this.form = fb.group({
      payer: fcf.createMandatory('INCORRECT_PAYMENT.PAYER', null),
    });
  }

  @Input() dataContext: IncorrectPayment;

  readonly form: FormGroup;
  payers: Payer[];

  cancel() {
    this._dialogService.close();
  }

  ngOnInit() {
    this._payerService.getList().subscribe(list => (this.payers = list));
  }

  onSubmit() {
    if (this.form.invalid) return;

    this.dataContext.payer = this.form.controls['payer'].value;

    this._paymentService.update(this.dataContext).subscribe(payment => {
      this._dialogService.complete(payment);
    });
  }
}
